import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.promise.js";
import { getClient, SDK_VERSION } from '@sentry/core';
import { WINDOW } from '../helpers.js';

// This is a map of integration function method to bundle file name.
var LazyLoadableIntegrations = {
  replayIntegration: 'replay',
  replayCanvasIntegration: 'replay-canvas',
  feedbackIntegration: 'feedback',
  feedbackModalIntegration: 'feedback-modal',
  feedbackScreenshotIntegration: 'feedback-screenshot',
  captureConsoleIntegration: 'captureconsole',
  contextLinesIntegration: 'contextlines',
  linkedErrorsIntegration: 'linkederrors',
  debugIntegration: 'debug',
  dedupeIntegration: 'dedupe',
  extraErrorDataIntegration: 'extraerrordata',
  httpClientIntegration: 'httpclient',
  reportingObserverIntegration: 'reportingobserver',
  rewriteFramesIntegration: 'rewriteframes',
  sessionTimingIntegration: 'sessiontiming',
  browserProfilingIntegration: 'browserprofiling',
  moduleMetadataIntegration: 'modulemetadata'
};
var WindowWithMaybeIntegration = WINDOW;

/**
 * Lazy load an integration from the CDN.
 * Rejects if the integration cannot be loaded.
 */
function lazyLoadIntegration(_x, _x2) {
  return _lazyLoadIntegration.apply(this, arguments);
}
function _lazyLoadIntegration() {
  _lazyLoadIntegration = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(name, scriptNonce) {
    var bundle, sentryOnWindow, existing, url, script, waitForLoad, currentScript, parent, integrationFn;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          bundle = LazyLoadableIntegrations[name]; // `window.Sentry` is only set when using a CDN bundle, but this method can also be used via the NPM package
          sentryOnWindow = WindowWithMaybeIntegration.Sentry = WindowWithMaybeIntegration.Sentry || {};
          if (bundle) {
            _context.next = 4;
            break;
          }
          throw new Error("Cannot lazy load integration: ".concat(name));
        case 4:
          // Bail if the integration already exists
          existing = sentryOnWindow[name]; // The `feedbackIntegration` is loaded by default in the CDN bundles,
          // so we need to differentiate between the real integration and the shim.
          // if only the shim exists, we still want to lazy load the real integration.
          if (!(typeof existing === 'function' && !('_isShim' in existing))) {
            _context.next = 7;
            break;
          }
          return _context.abrupt("return", existing);
        case 7:
          url = getScriptURL(bundle);
          script = WINDOW.document.createElement('script');
          script.src = url;
          script.crossOrigin = 'anonymous';
          script.referrerPolicy = 'origin';
          if (scriptNonce) {
            script.setAttribute('nonce', scriptNonce);
          }
          waitForLoad = new Promise(function (resolve, reject) {
            script.addEventListener('load', function () {
              return resolve();
            });
            script.addEventListener('error', reject);
          });
          currentScript = WINDOW.document.currentScript;
          parent = WINDOW.document.body || WINDOW.document.head || currentScript && currentScript.parentElement;
          if (!parent) {
            _context.next = 20;
            break;
          }
          parent.appendChild(script);
          _context.next = 21;
          break;
        case 20:
          throw new Error("Could not find parent element to insert lazy-loaded ".concat(name, " script"));
        case 21:
          _context.prev = 21;
          _context.next = 24;
          return waitForLoad;
        case 24:
          _context.next = 29;
          break;
        case 26:
          _context.prev = 26;
          _context.t0 = _context["catch"](21);
          throw new Error("Error when loading integration: ".concat(name));
        case 29:
          integrationFn = sentryOnWindow[name];
          if (!(typeof integrationFn !== 'function')) {
            _context.next = 32;
            break;
          }
          throw new Error("Could not load integration: ".concat(name));
        case 32:
          return _context.abrupt("return", integrationFn);
        case 33:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[21, 26]]);
  }));
  return _lazyLoadIntegration.apply(this, arguments);
}
function getScriptURL(bundle) {
  var client = getClient();
  var options = client && client.getOptions();
  var baseURL = options && options.cdnBaseUrl || 'https://browser.sentry-cdn.com';
  return new URL("/".concat(SDK_VERSION, "/").concat(bundle, ".min.js"), baseURL).toString();
}
export { lazyLoadIntegration };